<template>
  <div class="flex w-full flex-col">
    <p class="flex items-center">
      <span> Razón social: </span>
      <span class="ml-2 font-light">
        {{ companyName }}
      </span>
      <button
        class="ml-1"
        @click="copyToClipBoard(companyName, 'companyName')"
      >
        <ClipboardDocumentCheckIcon
          v-if="copiedStatus['companyName']"
          class="w-4 text-lk-green md:w-5"
        />
        <ClipboardDocumentIcon
          v-else
          class="w-4 md:w-5"
        />
      </button>
    </p>
    <p class="mt-1 flex items-center">
      <span> Rut: </span>
      <span class="ml-2 font-light">
        {{ lokalRut }}
      </span>
      <button
        class="ml-1"
        @click="copyToClipBoard(lokalRut, 'lokalRut')"
      >
        <ClipboardDocumentCheckIcon
          v-if="copiedStatus['lokalRut']"
          class="w-4 text-lk-green md:w-5"
        />
        <ClipboardDocumentIcon
          v-else
          class="w-4 md:w-5"
        />
      </button>
    </p>
    <p class="mt-1 flex items-center">
      <span> Giro: </span>
      <span class="ml-2 font-light">
        {{ lokalLineOfBusiness }}
      </span>
      <button
        class="ml-1"
        @click="copyToClipBoard(lokalLineOfBusiness, 'lokalLineOfBusiness')"
      >
        <ClipboardDocumentCheckIcon
          v-if="copiedStatus['lokalLineOfBusiness']"
          class="w-4 text-lk-green md:w-5"
        />
        <ClipboardDocumentIcon
          v-else
          class="w-4 md:w-5"
        />
      </button>
    </p>
    <p class="mt-1 flex items-center">
      <span> Banco: </span>
      <span class="ml-2 font-light">
        {{ bankName }}
      </span>
      <button
        class="ml-1"
        @click="copyToClipBoard(bankName, 'bankName')"
      >
        <ClipboardDocumentCheckIcon
          v-if="copiedStatus['bankName']"
          class="w-4 text-lk-green md:w-5"
        />
        <ClipboardDocumentIcon
          v-else
          class="w-4 md:w-5"
        />
      </button>
    </p>
    <p class="mt-1 flex items-center">
      <span> Cuenta Corriente: </span>
      <span class="ml-2 font-light">
        {{ lokalAccountNumber }}
      </span>
      <button
        class="ml-1"
        @click="copyToClipBoard(lokalAccountNumber, 'lokalAccountNumber')"
      >
        <ClipboardDocumentCheckIcon
          v-if="copiedStatus['lokalAccountNumber']"
          class="w-4 text-lk-green md:w-5"
        />
        <ClipboardDocumentIcon
          v-else
          class="w-4 md:w-5"
        />
      </button>
    </p>
    <p class="mt-1 flex items-center">
      <span> Correo: </span>
      <span class="ml-2 font-light">
        {{ billingEmail }}
      </span>
      <button
        class="ml-1"
        @click="copyToClipBoard(billingEmail, 'billingEmail')"
      >
        <ClipboardDocumentCheckIcon
          v-if="copiedStatus['billingEmail']"
          class="w-4 text-lk-green md:w-5"
        />
        <ClipboardDocumentIcon
          v-else
          class="w-4 md:w-5"
        />
      </button>
    </p>
    <p class="mt-1 flex items-center">
      <span> Dirección: </span>
      <span class="ml-2 font-light">
        {{ address }}
      </span>
      <button
        class="ml-1"
        @click="copyToClipBoard(address, 'address')"
      >
        <ClipboardDocumentCheckIcon
          v-if="copiedStatus['address']"
          class="w-4 text-lk-green md:w-5"
        />
        <ClipboardDocumentIcon
          v-else
          class="w-4 md:w-5"
        />
      </button>
    </p>
  </div>
</template>
<script lang="ts" setup>
import { ClipboardDocumentIcon, ClipboardDocumentCheckIcon } from '@heroicons/vue/24/outline';
import { computed, ref } from 'vue';
import useMessageStore from 'stores/message-store';

const DEFAULT_STATUS_TIMEOUT = 3000;

const messageStore = useMessageStore();

type CopiedStatusKeys = {
  companyName: boolean;
  lokalRut: boolean;
  bankName: boolean;
  lokalAccountNumber: boolean;
  billingEmail: boolean;
  lokalLineOfBusiness: boolean;
  address: boolean;
};
const copiedStatus = ref({
  companyName: false,
  lokalRut: false,
  bankName: false,
  lokalAccountNumber: false,
  billingEmail: false,
  address: false,
} as CopiedStatusKeys);
const companyName = computed(() => 'Lokal Spa');
const lokalRut = computed(() => process.env.LOKAL_RUT || '');
const lokalLineOfBusiness = computed(() => process.env.LOKAL_LINE_OF_BUSINESS || '');
const bankName = computed(() => 'Banco Bice');
const lokalAccountNumber = computed(() => process.env.LOKAL_ACCOUNT_NUMBER || '');
const billingEmail = computed(() => process.env.BILLING_EMAIL || '');
const address = computed(() => process.env.ADDRESS || '');

function backToDefaultStatus(statusKey: keyof CopiedStatusKeys) {
  copiedStatus.value[statusKey] = false;
}

function copyToClipBoard(value: string, statusKey: keyof CopiedStatusKeys) {
  navigator.clipboard.writeText(value).then(() => {
    copiedStatus.value[statusKey] = true;
    messageStore.showMessage(`"${value}" copiado al portapapeles`, 'success');
    setTimeout(() => backToDefaultStatus(statusKey), DEFAULT_STATUS_TIMEOUT);
  });
}
</script>
